function Cv() {
    return(
        <div>Cv</div>
    )
}

export default Cv;